export const appElId = 'kmx-hf';
export const CHAT_FAB_BOTTOM_DISTANCE = 85;
export const MR_CUTE_TEST_CUSTOM_EVENT = 'kmxMrCuteTestEvent';

export const OnlineAppraisalLocalStorageKey = 'suycMultipleIcoOffer';
